import React from "react";

const VisaLargeIcon = () => {
  return (
    <svg
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Visa"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.858 24H1.14296C0.511437 24 0 23.4738 0 22.8252V1.17485C0 0.5262 0.511437 0 1.14296 0H34.858C35.4897 0 36 0.5262 36 1.17485V22.8252C36 23.4738 35.4897 24 34.858 24Z"
        fill="#F6F6F9"
      />
      <g clipPath="url(#clip0_visa_large)">
        <path
          d="M15.1125 7.63715L11.9703 15.1338H9.92036L8.37411 9.15114C8.28024 8.78265 8.19861 8.64765 7.91312 8.4924C7.44699 8.23952 6.67725 7.99227 6 7.85502L6.04601 7.63715H9.34586C9.71649 7.63715 10.0446 7.91715 10.1401 8.40152L10.9567 12.7395L13.0749 7.63702H15.1125V7.63715ZM23.1447 12.6864C23.153 10.7078 20.4087 10.5988 20.4276 9.71489C20.4335 9.44589 20.6895 9.15989 21.2502 9.08689C21.528 9.05052 22.2936 9.02277 23.162 9.42239L23.5026 7.83266C23.0361 7.66328 22.4357 7.50027 21.6887 7.50027C19.7718 7.50027 18.4229 8.51927 18.4115 9.97839C18.399 11.0576 19.3743 11.6599 20.109 12.0185C20.8649 12.3858 21.1185 12.6218 21.1157 12.9503C21.1103 13.4531 20.5128 13.6751 19.9545 13.6839C18.9797 13.6989 18.414 13.4201 17.9633 13.2105L17.6117 14.8529C17.9648 15.0608 18.9012 15.2421 19.7684 15.2513C21.8057 15.2513 23.1384 14.2449 23.1447 12.6864ZM28.2065 15.134H30L28.4345 7.63715H26.779C26.4066 7.63715 26.0927 7.85389 25.9536 8.18715L23.0436 15.1338H25.0799L25.4841 14.0141H27.9723L28.2065 15.1338V15.134ZM26.0426 12.4778L27.0633 9.66302L27.6507 12.4778H26.0426ZM17.8833 7.63715L16.2797 15.1338H14.3405L15.9447 7.63715H17.8833Z"
          fill="#1434CB"
        />
      </g>
      <defs>
        <clipPath id="clip0_visa_large">
          <rect
            width="24"
            height="7.75097"
            fill="white"
            transform="translate(6 7.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default VisaLargeIcon;
